import React, { Component } from 'react'
import {
    Button,
    Form,
    Input,
    Select,
    Cascader,
    Upload,
    InputNumber,
    DatePicker,
    Spin,
    Icon,
    Modal,
    Popconfirm,
    Tree,
    Radio,
    AutoComplete
} from 'antd'
import { app, api, config } from "../../app"
import PropTypes from 'prop-types'
import _ from 'underscore'
import moment from 'moment'
import Mockjs from 'mockjs'
import date_locale from 'antd/lib/date-picker/locale/zh_CN'
import addressOptions from "../../util/cascader-address-options"
import command from "../notice/command"

const FormItem = Form.Item
const TextArea = Input.TextArea
const Option = Select.Option
const TreeNode = Tree.TreeNode

/**
 * 上传之前
 * @param file
 */
function beforeUpload (file) {
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    }
    return Promise.resolve(true)
}

function service_subjectToOptions (item, disabled = false) {
    let info = {
        value: item.id,
        label: item.subject_name,
    }
    if (disabled) info.disabled = true
    if (item.subclass) {
        info.children = item.subclass.map(s => {
            return service_subjectToOptions(s)
        })
    }
    return info
}

function getServiceSubjectId (items, id) {
    for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < items[i].children.length; j++) {
            if (items[i].children[j].value === id) {
                return [items[i].value, id]
            }
        }
    }
}

function searchPlayerByTeam (indexno, { NORZ,PTZYZ, RZ, ZYZ, administrator, teamheader, teamno }) {
    let players = []
    if (NORZ) {
        let item = _.find(NORZ, p => indexno === p.indexno)
        if (item) {
            players.push(`${teamno}-NORZ-${item.vname}-${item.indexno}`)
        }
    }
    if (RZ) {
        let item = _.find(RZ, p => indexno === p.indexno)
        if (item) {
            players.push(`${teamno}-RZ-${item.vname}-${item.indexno}`)
        }
    }
    if(PTZYZ){
        let item = _.find(PTZYZ, p => indexno === p.indexno)
        if (item) {
            players.push(`${teamno}-PTZYZ-${item.vname}`)
        }
    }
    if (ZYZ) {
        let item = _.find(ZYZ, p => indexno === p.indexno)
        if (item) {
            players.push(`${teamno}-ZYZ-${item.vname}-${item.indexno}`)
        }
    }
    if (administrator) {
        let item = _.find(administrator, p => indexno === p.indexno)
        if (item) {
            players.push(`${teamno}-administrator-${item.vname}-${item.indexno}`)
        }
    }
    if (teamheader) {
        let item = _.find(teamheader, p => indexno === p.indexno)
        if (item) {
            players.push(`${teamno}-teamheader-${item.vname}-${item.indexno}`)
        }
    }
    return players
}

class ReportAdd extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataInfo: {},
            loading: true,
            team_loading: true,
            player_modal: false,
            submit_loading: false,
            teamList: [],
            object_volunteer: { indexno: [], checks: [] },
            object_volunteer_rear: { indexno: [], checks: [] },
            playerList: {},
            playerChecks: [],
            searchplayerList: [],
            detailData: {},
            player_modal_key: null,
            modal_search_value: null,
            principal_type: null
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleDefaultData()
        await this.handleTeamData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 获取默认数据
     * @returns {Promise<void>}
     */
    handleDefaultData = async () => {
        await this.setData({ loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }, { flag, data, msg } = await app.post(api.ReportsOption, params)
        if (flag === 1) {
            data.service_subject = data.service_subject.map(s => service_subjectToOptions(s, true))
        } else {
            data = {}
            app.alert(msg, 'error')
        }
        let { edit_id } = this.props, state = {}
        if (edit_id) {
            state = await this.handleDetailData(edit_id, data.service_subject)
            const report_type = data.type.find(t => state.detailData.type === t.id) || {}
            data.service_subject = data.service_subject.map(s => {
                if (report_type && (report_type.sid || []).indexOf(s.value) !== -1) {
                    s.disabled = false
                } else {
                    s.disabled = true
                }
                return s
            })
        }
        await this.setData(Object.assign(state, { dataInfo: data, loading: false }))
    }

    /**
     * 获取报表详情数据
     * @param id
     * @param service_subject
     * @returns {Promise<*>}
     */
    handleDetailData = async (id, service_subject) => {
        let params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.ReportsDetails, params)
        if (flag === 1) {
            let { principal, object_volunteer, object_volunteer_rear, is_domestic } = data
            if (is_domestic === '1') {
                data.area = [data.province, data.city, data.region]
            }
            data.principal = principal ? principal.map(p => p.indexno) : []
            data.service_subject = getServiceSubjectId(service_subject, data.service_subject)
            let ov_vname = [], ov_indexno = [], ov_checks = [], ovr_vname = [], ovr_indexno = [], ovr_checks = []
            for (let i = 0; i < (object_volunteer || []).length; i++) {
                ov_vname.push(object_volunteer[i].vname)
                ov_indexno.push(object_volunteer[i].indexno)
                ov_checks.push(`3-${object_volunteer[i].vname}-${object_volunteer[i].indexno}`)
            }
            for (let j = 0; j < (object_volunteer_rear || []).length; j++) {
                ovr_vname.push(object_volunteer_rear[j].vname)
                ovr_indexno.push(object_volunteer_rear[j].indexno)
                ovr_checks.push(`3-${object_volunteer_rear[j].vname}-${object_volunteer_rear[j].indexno}`)
            }
            data.object_volunteer = ov_vname.join('、')
            data.object_volunteer_rear = ovr_vname.join('、')
            return {
                detailData: data,
                searchplayerList: principal,
                object_volunteer: { indexno: ov_indexno, checks: ov_checks },
                object_volunteer_rear: { indexno: ovr_indexno, checks: ovr_checks },
            }
        } else {
            app.alert(msg, "error")
            return {}

        }

    }

    /**
     * type 变更
     * @param type
     */
    handleTypeChange = (type) => {
        const { dataInfo } = this.state, report_type = dataInfo.type.find(t => type === t.id) || {}
        const service_subject = dataInfo.service_subject.map(s => {
            if (report_type && (report_type.sid || []).indexOf(s.value) !== -1) {
                s.disabled = false
            } else {
                s.disabled = true
            }
            return s
        })
        dataInfo.service_subject = [...service_subject]
        this.props.form.setFieldsValue({ service_subject: undefined })
        this.setData({ dataInfo })
    }

    /**
     * 获取队伍数据
     * @returns {Promise<void>}
     */
    handleTeamData = async () => {
        await this.setData({ team_loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }, { flag, data, msg } = await app.post(api.ReportsTeamAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ teamList: data, team_loading: false })
    }

    /**
     * 搜索人员数据
     * @returns {Promise<void>}
     */
    handleSearchPlayer = async (search_val) => {
        if (!search_val) {
            await this.setData({ searchplayerList: [] })
            return
        }
        await this.setData({ principal_loading: true })
        let params = {
            search_val,
            search_type: this.state.principal_type || 'searchform_name',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.HomeSearch, params)
        if (flag === 1) {
            let { object_volunteer, object_volunteer_rear } = this.state
            object_volunteer = object_volunteer.indexno.concat(object_volunteer_rear.indexno)
            data.forEach(ov => {
                ov.disabled = object_volunteer.indexOf(ov.indexno) !== -1
            })
        } else {
            data = []
            app.alert(msg, "error")
        }
        await this.setData({ searchplayerList: data, principal_loading: false })
    }

    /**
     * 表单提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        if (this.state.submit_loading) return
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                let { object_volunteer, object_volunteer_rear } = this.state, { teamno, onClose } = this.props
                values.principal = values.principal || []
                if (object_volunteer.indexno.length === 0 && object_volunteer_rear.indexno.length === 0 && values.principal.length === 0) {
                    app.alert("至少选择一名队员！", "warn")
                    return
                }
                await this.setData({ submit_loading: true })
                let event_img = []
                if (values.event_img) {
                    for (let i = 0; i < values.event_img.length; i++) {
                        let img = values.event_img[i]
                        if (img && img.response && img.response.flag === 1) {
                            event_img.push(img.response.data.url)
                        }
                    }
                }
                values.indexno = app.getData('indexno')
                values.account = app.getData('account')
                values.teamno = teamno
                values.service_subject = values.service_subject[values.service_subject.length - 1]  //志愿服务科目
                values.action_people_number = object_volunteer.indexno.length + object_volunteer_rear.indexno.length + (values.principal || []).length
                values.principal = (values.principal || []).join(',')
                values.event_time = values.event_time.format('YYYY-MM-DD HH:mm:00')
                if (values.is_domestic === '1') {
                    values.province = values.area[0]
                    values.city = values.area[1]
                    values.region = values.area[2]
                }
                values.object_team = values.object_team.join(',')
                values.object_volunteer = object_volunteer.indexno.join(',')
                values.object_volunteer_rear = object_volunteer_rear.indexno.join(',')
                values.action_time = values.action_time.format('YYYY-MM-DD HH:mm:00')
                values.recruit_time = values.recruit_time ? values.recruit_time.format('YYYY-MM-DD HH:mm:00') : ''
                values.event_img = event_img.join(':::')
                let params = Object.assign({}, values)
                delete params.area
                let { edit_id } = this.props, result = { flag: 0 }, msg = "提交"
                if (edit_id) {
                    params.id = edit_id
                    msg = '编辑'
                    result = await app.post(api.ReportsEdit, params)
                } else {
                    result = await app.post(api.ReportsAdd, params)
                }
                await this.setData({ submit_loading: false })
                if (result.flag === 1) {
                    app.alert(msg + "成功", "success")
                    onClose(true)
                } else {
                    app.alert(result.msg || (msg + "失败"), "error")
                }
            }
        })
    }

    /**
     * 表单清空
     */
    handleReset = () => {
        this.props.form.resetFields()
    }

    /**
     * 选择队员
     */
    handleSelectPlayer = async (key) => {
        const teams = this.props.form.getFieldValue('object_team')
        if (teams && teams.length > 0) {
            app.alert('正在加载内容~', 'loading')
            const params = {
                teamno: teams.join(','),
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            }
            let { flag, data, msg } = await app.post(api.ReportsGetTeamUserAll, params)
            app.alertDestroy()
            if (flag !== 1) {
                app.alert(msg, "error")
                data = []
            }
            let state = { playerList: data, player_modal: true, player_modal_key: key }
            switch (key) {
                case "1":
                    state.playerChecks = this.state.object_volunteer.checks || []
                    break
                case "2":
                    state.playerChecks = this.state.object_volunteer_rear.checks || []
                    break
            }
            await this.setData(state)
        } else {
            app.alert('请先选择出队队伍！', 'warn')
        }
    }

    /**
     * 关闭队员选择框
     * @returns {Promise<void>}
     */
    handleClosePlayerModal = async () => {
        await this.setData({ player_modal: false, playerChecks: [], modal_search_value: '' })
    }

    /**
     * 选择队员
     * @param playerChecks
     */
    handleSelPlayer = (playerChecks) => {
        this.setData({ playerChecks })
    }

    /**
     * 确认选择队员
     * @param e
     */
    handleConfirmPlayerSel = (e) => {
        e.preventDefault()
        let { playerChecks, player_modal_key } = this.state,
            principal = this.props.form.getFieldValue('principal') || []
        // if (playerChecks.length > 0) {
        let vnames = [], indexnos = [], has_vname = []
        switch (player_modal_key) {
            case "1":
                let { object_volunteer_rear } = this.state
                for (let i = 0; i < playerChecks.length; i++) {
                    let arr = playerChecks[i].split('-')
                    if (arr.length === 3 && indexnos.indexOf(arr[2]) === -1) {
                        vnames.push(arr[1])
                        indexnos.push(arr[2])
                        if (principal.concat(object_volunteer_rear.indexno).indexOf(arr[2]) !== -1) {
                            has_vname.push(arr[1])
                        }
                    }
                }
                if (has_vname.length > 0) {
                    app.alert(`现场指挥或后台出队队员已包含【${has_vname.join('、')}】`, 'warn', '40%', 2.5)
                    return
                }
                this.props.form.setFieldsValue({
                    object_volunteer: vnames.join('、')
                })
                this.state.object_volunteer.indexno = indexnos
                this.state.object_volunteer.checks = playerChecks
                break
            case "2":
                let { object_volunteer } = this.state
                for (let i = 0; i < playerChecks.length; i++) {
                    let arr = playerChecks[i].split('-')
                    if (arr.length === 3 && indexnos.indexOf(arr[2]) === -1) {
                        vnames.push(arr[1])
                        indexnos.push(arr[2])
                        if (principal.concat(object_volunteer.indexno).indexOf(arr[2]) !== -1) {
                            has_vname.push(arr[1])
                        }
                    }
                }
                if (has_vname.length > 0) {
                    app.alert(`现场指挥或现场出队队员已包含【${has_vname.join('、')}】`, 'warn', '40%', 2.5)
                    return
                }
                this.props.form.setFieldsValue({
                    object_volunteer_rear: vnames.join('、')
                })
                this.state.object_volunteer_rear.indexno = indexnos
                this.state.object_volunteer_rear.checks = playerChecks
                break
        }
        this.setData({ player_modal: false, modal_search_value: '' })
        // } else {
        //     app.alert("请选择队员！")
        // }
    }

    /**
     * 选择出队队员搜索
     **/
    handleModalSearchPlayer = (modal_search_value) => this.setData({ modal_search_value })

    handleAuto = () => {
        let { dataInfo } = this.state
        this.props.form.setFieldsValue({
            department: "测试部门",
            type: '8',
            service_subject: ['1', '9'],
            title: Mockjs.mock('@cparagraph'),
            principal: ['吉00020072'],
            relevant: Mockjs.mock('@cname'),
            event_time: moment(),
            is_domestic: '1',
            area: ["河北省", "秦皇岛市", "抚宁区"],
            address: Mockjs.mock('@county'),
            request_object: Mockjs.mock('@cname'),
            request_object_contact: '13666666666',
            reporter: Mockjs.mock('@cname'),
            reporter_contact: '13666666666',
            action_time: moment(),
            recruit_time: moment().add(3, 'days'),
            action_car_number: Mockjs.mock({
                "number|1-100": 100
            }).number,
            number_plate: '粤' + Mockjs.mock('@string("upper", 6)'),
            other_tools: '其它',
            whether_succeed: dataInfo.whether_succeed[0].id,
            event_progress: Mockjs.mock('@csentence'),
            service_time: Mockjs.mock({
                "number|1-100": 100
            }).number,
            benefit_number: Mockjs.mock({
                "number|1-100": 100
            }).number,
            summary_person: Mockjs.mock('@cname'),
            task_summary: Mockjs.mock('@cparagraph'),
            web_link: Mockjs.mock('@url'),
            object_team: ["云0001", "粤0004"],
            object_volunteer: "郭台伟、刘芯、佛山一姐、杨光军、胡宇翔、池翔、何国旋、陈丹辉、何国庆、刘宇斌、张红、南海三哥",
            object_volunteer_rear: "孙振海、黄亮、张靖昊、HHF、MMN、王凯、罗丽娜、钟其桀、杨秋云、AAS",
        })
        this.setData({
            object_volunteer: {
                indexno: ["粤00040002", "粤00030050", "粤00030053", "粤00040063", "粤00040011", "粤00040888", "粤00030052", "粤00040033", "川00100011", "粤00040051", "粤00040034", "粤00110004"],
                checks: ["广东存心救援队", "广东存心救援队-teamheader", "3-郭台伟-粤00040002", "广东存心救援队-administrator", "3-刘芯-粤00030050", "3-佛山一姐-粤00030053", "广东存心救援队-RZ", "3-杨光军-粤00040063", "3-胡宇翔-粤00040011", "3-池翔-粤00040888", "3-何国旋-粤00030052", "广东存心救援队-NORZ", "3-陈丹辉-粤00040033", "3-何国庆-川00100011", "广东存心救援队-ZYZ", "3-刘宇斌-粤00040051", "3-张红-粤00040034", "3-南海三哥-粤00110004"],
            },
            object_volunteer_rear: {
                indexno: ["云00010001", "云00010003", "云00010005", "云00010010", "云00010009", "云00010006", "云00010007", "粤00030051", "贵00030002", "云00010011"],
                checks: ["云南存心救援总队-teamheader", "3-孙振海-云00010001", "3-黄亮-云00010003", "云南存心救援总队-NORZ", "3-张靖昊-云00010005", "3-HHF-云00010010", "云南存心救援总队-ZYZ", "3-MMN-云00010009", "3-王凯-云00010006", "3-罗丽娜-云00010007", "3-钟其桀-粤00030051", "3-杨秋云-贵00030002", "3-AAS-云00010011"]
            }
        })
    }

    render () {
        let { edit_id, form, onDuration } = this.props,
            { getFieldDecorator, getFieldsValue, setFieldsValue } = form,
            {
                dataInfo, loading, object_volunteer, team_loading, teamList, searchplayerList, playerList, principal_loading,
                player_modal, playerChecks, submit_loading, detailData, object_volunteer_rear, modal_search_value
            } = this.state,
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 14 },
            },
            formData = getFieldsValue(['object_team', 'is_domestic', 'service_subject', 'action_time', 'whether_succeed', 'event_img', 'principal']),
            default_time_value = moment().second(0),
            dtv_minute = default_time_value.minute(),
            player_modal_search_count = 0
        const loopPlayerTreeNode = ({ vname, bsrno, indexno }) => {
            if(bsrno){
                let title = `${vname}【${bsrno}】`
                if (modal_search_value && (vname.indexOf(modal_search_value) > -1 || bsrno.indexOf(modal_search_value) > -1)) {
                    const index = title.indexOf(modal_search_value)
                    const beforeStr = title.substr(0, index)
                    const afterStr = title.substr(index + modal_search_value.length)
                    player_modal_search_count += 1
                    title = (
                        <span>
                            {beforeStr}
                            <span style={{ backgroundColor: "rgb(143, 178, 201)" }}>{modal_search_value}</span>
                            {afterStr}
                        </span>
                    )
                }
                let pmsc = document.getElementById('player_modal_search_count')
                if (pmsc) pmsc.innerHTML = `搜索记录数：${player_modal_search_count}条`
    
                return (
                    <TreeNode
                        title={title}
                        key={`3-${vname}-${indexno}`}
                    />
                )
        }else{
            let title = `${vname}`
            if (modal_search_value && (vname.indexOf(modal_search_value) > -1 || bsrno.indexOf(modal_search_value) > -1)) {
                const index = title.indexOf(modal_search_value)
                const beforeStr = title.substr(0, index)
                const afterStr = title.substr(index + modal_search_value.length)
                player_modal_search_count += 1
                title = (
                    <span>
                        {beforeStr}
                        <span style={{ backgroundColor: "rgb(143, 178, 201)" }}>{modal_search_value}</span>
                        {afterStr}
                    </span>
                )
            }
            let pmsc = document.getElementById('player_modal_search_count')
            if (pmsc) pmsc.innerHTML = `搜索记录数：${player_modal_search_count}条`

            return (
                <TreeNode
                    title={title}
                    key={`3-${vname}-${indexno}`}
                />
            )
        }
        }
        if (edit_id && !formData.is_domestic) {
            formData.is_domestic = detailData.is_domestic
        }
        if (dtv_minute >= 30) {
            default_time_value.minute(30)
        } else {
            default_time_value.minute(0)
        }
        return loading ? (
            <div style={{ marginTop: "35vh", textAlign: "center" }}><Spin size="large"/></div>
        ) : (
            <Form onSubmit={this.handleSubmit}>
                <FormItem
                    label="账号"
                    {...formItemLayout}
                >
                    <span className="ant-form-text">{(edit_id ? detailData.account : dataInfo.account) || '-'}</span>
                </FormItem>
                <FormItem
                    label="创建人"
                    {...formItemLayout}
                >
                    <span className="ant-form-text">{(edit_id ? detailData.vname : dataInfo.vname) || '-'}</span>
                </FormItem>
                <FormItem
                    label="参与部门"
                    {...formItemLayout}
                >
                    {getFieldDecorator('department', {
                        rules: [{ required: true, message: "参与部门必填！" }],
                        initialValue: detailData.department
                    })(
                        <TextArea placeholder="如水域组、绳索组等" autosize={{ maxRows: 3, minRows: 2 }}
                                  disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="服务类型"
                    {...formItemLayout}
                >
                    {getFieldDecorator('type', {
                        rules: [{ required: true, message: "服务类型必选！" }],
                        initialValue: detailData.type
                    })(
                        <Select placeholder="请选择" disabled={detailData.edit_status === '1'}
                                onChange={this.handleTypeChange}>
                            {
                                (dataInfo.type || []).map(t => {
                                    return (
                                        <Option key={t.id} value={t.id}>{t.name}</Option>
                                    )
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    label="服务科目"
                    {...formItemLayout}
                >
                    {getFieldDecorator('service_subject', {
                        rules: [{ required: true, message: "服务科目必选！" }],
                        initialValue: edit_id ? detailData.service_subject : undefined
                    })(
                        <Cascader options={dataInfo.service_subject || []} disabled={detailData.edit_status === '1'}
                                  placeholder="请选择" notFoundContent="无记录"/>
                    )}
                </FormItem>
                <FormItem
                    label="服务项目名称"
                    {...formItemLayout}
                >
                    {getFieldDecorator('title', {
                        rules: [{ required: true, message: "服务项目名称必填！" }],
                        initialValue: detailData.title

                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="相关人"
                    {...formItemLayout}
                >
                    {getFieldDecorator('relevant', {
                        initialValue: detailData.relevant || ''
                    })(
                        <TextArea placeholder="参与本次活动的其他编外人员" autosize={{ maxRows: 3, minRows: 2 }}
                                  disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="报案人"
                    {...formItemLayout}
                >
                    {getFieldDecorator('reporter', {
                        initialValue: detailData.reporter || ''
                    })(
                        <Input disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="报案人联系方式"
                    {...formItemLayout}
                >
                    {getFieldDecorator('reporter_contact', {
                        initialValue: detailData.reporter_contact || ''
                    })(
                        <Input disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="服务对象"
                    {...formItemLayout}
                >
                    {getFieldDecorator('request_object', {
                        initialValue: detailData.request_object || ''
                    })(
                        <Input disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="服务对象联系方式"
                    {...formItemLayout}
                >
                    {getFieldDecorator('request_object_contact', {
                        initialValue: detailData.request_object_contact || ''
                    })(
                        <Input disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="首次接触事务时间"
                    {...formItemLayout}
                >
                    {getFieldDecorator('event_time', {
                        rules: [{ required: true, message: "首次接触事务时间必选！" }],
                        initialValue: detailData.event_time ? moment(detailData.event_time) : undefined
                    })(
                        <DatePicker style={{ width: "100%" }} locale={date_locale} showTime
                                    format="YYYY年MM月DD日 HH:mm" disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="救援范围"
                    {...formItemLayout}
                >
                    {getFieldDecorator('is_domestic', {
                        rules: [{ required: true, message: "救援范围必选！" }],
                        initialValue: detailData.is_domestic || "1"
                    })(
                        <Select placeholder="请选择" disabled={detailData.edit_status === '1'}>
                            <Option value="1">国内</Option>
                            <Option value="2">国外</Option>
                        </Select>
                    )}
                </FormItem>
                {
                    formData.is_domestic === "1" ? (
                        <FormItem
                            label="省市区"
                            {...formItemLayout}
                        >
                            {getFieldDecorator('area', {
                                rules: [{ required: true, message: "省市区必选！" }],
                                initialValue: detailData.area || undefined
                            })(
                                <Cascader options={addressOptions} disabled={detailData.edit_status === '1'}
                                          placeholder="请选择" notFoundContent="无记录" showSearch/>
                            )}
                        </FormItem>
                    ) : null
                }
                <FormItem
                    label="具体地址"
                    {...formItemLayout}
                >
                    {getFieldDecorator('address', {
                        rules: [{ required: true, message: "具体地址必填！" }],
                        initialValue: detailData.address
                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="任务负责人/现场指挥"
                    {...formItemLayout}
                >
                    <span className="ant-form-text">
                        <Select placeholder="请选择" defaultValue="searchform_name" style={{width: 100}} onChange={(value) => this.setData({principal_type: value})}>
                            <Option value="searchform_name">队员名称</Option>
                            <Option value="searchform_code">存心编号</Option>
                        </Select>
                    </span>
                    {getFieldDecorator('principal', {
                        rules: formData.service_subject && '13'.indexOf(formData.service_subject[0]) === -1 ? [] : [{
                            required: true,
                            message: "现场指挥必选！"
                        }],
                        initialValue: detailData.principal
                    })(
                        <Select placeholder="请输入关键字搜索" onSearch={this.handleSearchPlayer}
                                notFoundContent={principal_loading ? <Spin size="small"/> : "无搜索内容"}
                                defaultActiveFirstOption={false}
                                showArrow={false}
                                disabled={detailData.edit_status === '1'}
                                filterOption={false}
                                mode="multiple"
                                style={{width: '80%'}}
                                allowClear
                                showSearch>
                            {
                                (searchplayerList || []).map(p => {
                                    return (
                                        <Option key={p.indexno} disabled={p.disabled}
                                                value={p.indexno}>{`${p.vname}（${p.bsrno || '-'}）`}</Option>
                                    )
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    label="出队队伍"
                    {...formItemLayout}
                >
                    {getFieldDecorator('object_team', {
                        rules: [{ required: true, message: "出队队伍必选！" }],
                        initialValue: detailData.object_team
                    })(
                        <Select placeholder="请选择" notFoundContent={team_loading ? <Spin size="small"/> : '查询无记录'}
                                optionFilterProp="children" mode="multiple" disabled={detailData.edit_status === '1'}
                                allowClear showSearch>
                            {
                                (teamList || []).map(t => {
                                    return (
                                        <Option key={t.team_id} value={t.teamno}>{t.teamname}</Option>
                                    )
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    label="现场出队队员"
                    {...formItemLayout}
                >
                    {getFieldDecorator('object_volunteer', {
                        rules: formData.service_subject && '123'.indexOf(formData.service_subject[0]) === -1 ? [] : [{
                            required: true,
                            message: "现场出队队员必选！"
                        }],
                        initialValue: detailData.object_volunteer
                    })(
                        <TextArea style={{ cursor: "pointer" }} placeholder="选择出队队伍后即可点击选择" readOnly
                                  onClick={() => this.handleSelectPlayer("1")} disabled={detailData.edit_status === '1'}
                                  autosize={{ maxRows: 6, minRows: 2 }}/>
                    )}
                </FormItem>
                <FormItem
                    label="后台出队队员"
                    {...formItemLayout}
                >
                    {getFieldDecorator('object_volunteer_rear', {
                        initialValue: detailData.object_volunteer_rear
                    })(
                        <TextArea style={{ cursor: "pointer" }} placeholder="选择出队队伍后即可点击选择" readOnly
                                  onClick={() => this.handleSelectPlayer("2")} disabled={detailData.edit_status === '1'}
                                  autosize={{ maxRows: 6, minRows: 2 }}/>
                    )}
                </FormItem>
                <FormItem
                    label="出队人数"
                    {...formItemLayout}
                >
                    <span className="ant-form-text">
                        <span>{object_volunteer.indexno.length + object_volunteer_rear.indexno.length + (formData.principal || []).length} 人</span>
                        <span style={{ color: 'red', marginLeft: 40 }}>注：包括现场指挥、现场出队队员、后台出队队员。</span>
                    </span>
                </FormItem>
                <FormItem
                    label="出队时间"
                    {...formItemLayout}
                >
                    {getFieldDecorator('action_time', {
                        rules: [{ required: true, message: "出队时间必选！" }],
                        initialValue: detailData.action_time ? moment(detailData.action_time) : undefined
                    })(
                        <DatePicker style={{ width: "100%" }} locale={date_locale}
                                    showTime={{ format: "HH:mm", minuteStep: 30 }}
                                    disabled={edit_id || detailData.edit_status === '1' ? true : false}
                                    showToday={false}
                                    disabledDate={(current) => {
                                        if (!current) return
                                        //return current > moment().startOf('day');
                                        return current && current > moment().endOf('day');
                                        //let c = moment(current).endOf('day')
                                        //return c < moment().subtract(2, 'day').endOf('day') || c > moment().endOf('day')
                                        //return c;
                                    }}
                                    defaultPickerValue={default_time_value}
                                    onOk={() => {
                                        setFieldsValue({ recruit_time: null })
                                    }}
                                    format="YYYY年MM月DD日 HH:mm"/>
                    )}
                    <div style={{ color: "red" }}>注：系统即日(2022-01-01)起现开放6个月内时间窗口供管理员补录工作简报，请尽快如实上传；此窗口期到2022年06月01日结束。窗口期到期后将恢复3天内任务上报限制。</div>
                    {/*<div style={{ color: "red" }}>注：只允许上传3天内的任务报表（前天，昨天，今天），出队时间不允许修改</div>*/}
                    {/*<div style={{ color: "red" }}>注：允许上传1个月内的任务报表（截止于7月15号），出队时间不允许修改</div>*/}
                </FormItem>
                <FormItem
                    label="是否完成"
                    {...formItemLayout}
                >
                    {getFieldDecorator('whether_succeed', {
                        rules: [{ required: true, message: "是否完成必选！" }],
                        initialValue: detailData.whether_succeed
                    })(
                        <Select placeholder="请选择"
                                disabled={detailData.whether_succeed === '11' || detailData.edit_status === '1'}>
                            {
                                (dataInfo.whether_succeed || []).map(w => {
                                    return (
                                        <Option key={w.id} value={w.id}>{w.name}</Option>
                                    )
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    label="收队时间"
                    {...formItemLayout}
                >
                    {getFieldDecorator('recruit_time', {
                        rules: formData.whether_succeed === '11' ? [{ required: true, message: "收队时间必选！" }] : [],
                        initialValue: detailData.recruit_time ? moment(detailData.recruit_time) : undefined
                    })(
                        <DatePicker style={{ width: "100%" }} locale={date_locale}
                                    disabled={!formData.action_time || detailData.whether_succeed === '11' || detailData.edit_status === '1'}
                                    disabledDate={(current) => {
                                        let day = moment(current).endOf('day')
                                        return current && (day < moment(formData.action_time).endOf('day') || day > moment().endOf('day'))
                                    }}
                                    showTime={{ format: "HH:mm", minuteStep: 30 }}
                                    showToday={false}
                                    defaultPickerValue={default_time_value}
                                    format="YYYY年MM月DD日 HH:mm"/>
                    )}
                    <div style={{ color: "red", lineHeight: 1.5 }}>注：任务【已完成】状态，按收队时间计算，三天内的报表可以进行内容编辑，三天后报表固化后就不能再修改
                    </div>
                </FormItem>
                <FormItem
                    label="出队车辆数"
                    {...formItemLayout}
                >
                    {getFieldDecorator('action_car_number', {
                        initialValue: detailData.action_car_number ? parseInt(detailData.action_car_number) : 0
                    })(
                        <InputNumber min={0} precision={0} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="车牌号码"
                    {...formItemLayout}
                >
                    {getFieldDecorator('number_plate', {
                        initialValue: detailData.number_plate || ''
                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="其他工具"
                    {...formItemLayout}
                >
                    {getFieldDecorator('other_tools', {
                        initialValue: detailData.other_tools || ''
                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="事件进展"
                    {...formItemLayout}
                >
                    {getFieldDecorator('event_progress', {
                        rules: [{ required: true, message: "事件进展必填！" }],
                        initialValue: detailData.event_progress
                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label={edit_id ? "服务时长" : "服务时长/人"  }

                    {...formItemLayout}
                >
                    {!edit_id ? getFieldDecorator('service_time', {
                        rules: [{ required: true, message: "服务时长必填！" }],
                        initialValue: detailData.service_time ? Number(detailData.service_time) : undefined
                    })(
                        <InputNumber min={0.5} precision={1} step={0.5}
                                     disabled={edit_id || detailData.edit_status === '1' ? true : false}
                                      />
                    ) : ''}
                    {
                        edit_id ?
                            (<span style={{ paddingLeft: 20 }}><Button type="primary"
                                                                       onClick={() => onDuration(edit_id)}>服务时长管理</Button></span>) : null
                    }
                </FormItem>
                <FormItem
                    label="受益人数"
                    {...formItemLayout}
                >
                    {getFieldDecorator('benefit_number', {
                        initialValue: detailData.benefit_number ? Number(detailData.benefit_number) : 0
                    })(
                        <InputNumber min={0} precision={0} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="任务总结"
                    {...formItemLayout}
                >
                    {getFieldDecorator('task_summary', {
                        initialValue: detailData.task_summary || ''
                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="总结人"
                    {...formItemLayout}
                >
                    {getFieldDecorator('summary_person', {
                        initialValue: detailData.summary_person || ''
                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="百度网盘链接"
                    {...formItemLayout}
                >
                    {getFieldDecorator('web_link', {
                        initialValue: detailData.web_link || ''
                    })(
                        <TextArea autosize={{ maxRows: 3, minRows: 2 }} disabled={detailData.edit_status === '1'}/>
                    )}
                </FormItem>
                <FormItem
                    label="事件图片"
                    {...formItemLayout}
                >
                    {getFieldDecorator('event_img', {
                        rules: [
                            { required: true, message: "事件图片必传！" },
                        ],
                        valuePropName: 'fileList',
                        getValueFromEvent: (e) => {
                            if (Array.isArray(e)) {
                                return e
                            }
                            return e && e.fileList
                        },
                        initialValue: edit_id ? (detailData.event_img || []).map((img, i) => {
                            i += 1
                            return {
                                uid: i - i * 2,
                                status: 'done',
                                response: {
                                    flag: 1,
                                    data: {
                                        url: img
                                    }
                                },
                                name: "图片" + i,
                                thumbUrl: config.imgUrl + img
                            }
                        }) : []
                    })(
                        <Upload
                            accept='image/jpeg, image/jpg, image/png'
                            action={config.serverUrl + api.ImageUpload}
                            disabled={formData.event_img && formData.event_img.length >= 10}
                            beforeUpload={beforeUpload}
                            data={{
                                token: app.getData('token'),
                                indexno: app.getData('indexno'),
                                account: app.getData('account'),
                                upload_type: 'reports'
                            }}
                            name="image"
                            listType="picture"
                            showUploadList={detailData.edit_status === '1' ? { showRemoveIcon: false } : true}
                            className="upload-list-inline"
                        >
                            <Button
                                disabled={(formData.event_img && formData.event_img.length >= 10) || detailData.edit_status === '1'}>
                                <Icon type="upload"/> 点击上传
                            </Button>
                        </Upload>
                    )}
                    <div style={{ color: "red" }}>注：图片限制上传10张。</div>
                </FormItem>
                <FormItem
                    label="保密"
                    {...formItemLayout}
                >
                    {getFieldDecorator('secret', {
                        rules: [{ required: true, message: "请选择是否保密！" }],
                        initialValue: detailData.secret || undefined
                    })(
                        <Radio.Group disabled={detailData.edit_status === '1'}>
                            <Radio value="1">是</Radio>
                            <Radio value="0">否</Radio>
                        </Radio.Group>
                    )}
                    <div style={{ color: "red", lineHeight: '24px' }}>注：设置为保密任务：服务项目名称、事件进展、任务总结、总结人、事件图片等不对外公开显示。</div>
                </FormItem>
                {
                    detailData.edit_status === '1' ? null : (
                        <FormItem
                            wrapperCol={{ span: 12, offset: 6 }}
                        >
                            <Popconfirm title="确定清空表单吗？" onConfirm={this.handleReset} okText="确定" cancelText="取消">
                                <Button>清空表单</Button>
                            </Popconfirm>
                            <Button type="primary" htmlType="submit" style={{ margin: "0 20px" }}
                                    loading={submit_loading}>提交</Button>
                            {/*<Button type="primary" onClick={this.handleAuto}>一键填写</Button>*/}
                        </FormItem>
                    )
                }
                <Modal
                    visible={player_modal}
                    title="选择出队队员"
                    onCancel={this.handleClosePlayerModal}
                    onOk={this.handleConfirmPlayerSel}
                    width={800}
                    zIndex={1001}
                    maskClosable={false}
                    destroyOnClose={true}
                    centered
                    okText="确定"
                    cancelText="取消"
                    bodyStyle={{ minHeight: 400, maxHeight: "calc(100vh - 160px)", height: "auto", overflowY: "auto" }}
                    style={{ paddingBottom: 20 }}
                >
                    <Input.Search placeholder="输入姓名或存心编号搜索" onSearch={this.handleModalSearchPlayer}/>
                    <div hidden={!modal_search_value} style={{ marginTop: 12, backgroundColor: "rgb(143, 178, 201)" }}
                         id='player_modal_search_count'/>
                    <Tree
                        checkable
                        defaultExpandAll
                        onCheck={this.handleSelPlayer}
                        checkedKeys={playerChecks}
                    >
                        <TreeNode title="所有队员" key="0">
                            {
                                Object.keys(playerList).map((player, pli) => {
                                    let pInfo = playerList[player]
                                    return (
                                        <TreeNode title={player} key={player}>
                                            {
                                                Object.keys(pInfo).map((sf, si) => {
                                                    let sfInfo = pInfo[sf]
                                                    return sfInfo.length > 0 && sf !== "teamno" && sf !== "province" ? (
                                                        <TreeNode
                                                            title={command.checkSF(sf)}
                                                            key={`${player}-${sf}`}>
                                                            {sfInfo.map((p1, pi) => {
                                                                return loopPlayerTreeNode(p1)
                                                            })}
                                                        </TreeNode>
                                                    ) : null
                                                })
                                            }
                                        </TreeNode>
                                    )
                                })
                            }
                        </TreeNode>
                    </Tree>
                </Modal>
            </Form>
        )
    }
}

ReportAdd.propTypes = {
    onClose: PropTypes.func.isRequired,
    onDuration: PropTypes.func.isRequired,
    setFormClear: PropTypes.func,
    teamno: PropTypes.any,
    edit_id: PropTypes.any,
}

export default Form.create()(ReportAdd)



// WEBPACK FOOTER //
// ./src/routes/sign/ReportAdd.jsx